import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "print-template" }
const _hoisted_2 = { id: "part1" }
const _hoisted_3 = { style: {"text-align":"center","font-size":"20px","font-weight":"bold"} }
const _hoisted_4 = { style: {"display":"flex","width":"100%"} }
const _hoisted_5 = { id: "part2" }
const _hoisted_6 = { style: {"display":"flex","width":"100%","border":"1px solid #000","padding":"10px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_vxe_column = _resolveComponent("vxe-column")!
  const _component_vxe_table = _resolveComponent("vxe-table")!
  const _component_ZPreview = _resolveComponent("ZPreview")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.printDetail.titleDetail.name), 1),
      _cache[0] || (_cache[0] = _createElementVNode("h3", { style: {"text-align":"center","font-size":"20px","font-weight":"bold"} }, "销售合同", -1)),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_descriptions, {
          column: 1,
          style: {"width":"49.5%"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_descriptions_item, { label: "需    方：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.printDetail.customerCompanyDetail.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "供    方：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.printDetail.titleDetail.name), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_descriptions, { column: 1 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_descriptions_item, { label: "报价编号 :" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.printDetail.no), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _cache[1] || (_cache[1] = _createElementVNode("h4", { class: "form-title" }, "报价明细：", -1))
    ]),
    _createVNode(_component_vxe_table, {
      border: "",
      "show-footer": "",
      ref: "xTable",
      align: "center",
      class: "mt-20",
      "print-config": _ctx.tablePrint,
      "keep-source": "",
      "auto-resize": "",
      "column-config": { resizable: true },
      "footer-method": _ctx.footerMethod,
      "merge-footer-items": _ctx.mergeFooterItems,
      data: _ctx.printDetail.details
    }, {
      default: _withCtx(() => [
        _createVNode(_component_vxe_column, {
          field: "index",
          width: "50",
          title: "序号"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.index), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          field: "businessName",
          title: "产品名称",
          "min-width": "120"
        }),
        _createVNode(_component_vxe_column, {
          field: "businessModel",
          title: "型号",
          "min-width": "120"
        }),
        _createVNode(_component_vxe_column, {
          field: "unit",
          title: "单位",
          width: "60"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.unit || row.businessUnit), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          field: "amount",
          title: "数量",
          width: "60"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.amount || row.businessAmount), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          field: "price",
          title: "单价",
          "min-width": "100",
          "header-align": "center"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_ctx.$currency(row.price)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          field: "totalPrice",
          title: "总价",
          "min-width": "100",
          "header-align": "center"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_ctx.$currency((row.price || 0) * 1 * (row.amount || 0) * 1)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          field: "mark",
          title: "备注",
          "min-width": "100"
        })
      ]),
      _: 1
    }, 8, ["print-config", "footer-method", "merge-footer-items", "data"]),
    _createElementVNode("div", _hoisted_5, [
      _cache[2] || (_cache[2] = _createElementVNode("h4", { class: "form-title" }, "备注：", -1)),
      _createElementVNode("pre", null, _toDisplayString(_ctx.printDetail.quotationMarkTemplateDetail.mark) + " ", 1),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_el_descriptions, {
          column: 1,
          style: {"width":"49.5%"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_descriptions_item, { label: "需方签字盖章" }),
            _createVNode(_component_el_descriptions_item, { label: "公司名称：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.printDetail.customerCompanyDetail.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "地       址：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.printDetail.receivingEmail), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "电        话：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.printDetail.customerCompanyContactDetail.phone), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "传        真：" }),
            _createVNode(_component_el_descriptions_item, { label: "开户银行：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.printDetail.customerTicketTitleDetail.bank), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "银行账号：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.printDetail.customerTicketTitleDetail.account), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "税        号：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.printDetail.customerTicketTitleDetail.taxId), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "委托代表：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.printDetail.customerCompanyContactDetail.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "日        期：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(new Date().toLocaleDateString().replace(/\//g, '-')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_descriptions, {
          column: 1,
          style: {"position":"relative"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_descriptions_item, { label: "供方签字盖章" }),
            _createVNode(_component_el_descriptions_item, { label: "公司名称：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.printDetail.titleDetail.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "地        址：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.printDetail.titleDetail.officeAddress), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "Tel 电话：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.printDetail.salesManDetail.phone), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "Line 座机：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.printDetail.titleDetail.phone), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "开户银行：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.printDetail.titleDetail.bank), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "银行账号：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.printDetail.titleDetail.account), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "税        号：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.printDetail.titleDetail.taxId), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "委托代表：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.printDetail.salesManDetail.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "日        期：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(new Date().toLocaleDateString().replace(/\//g, '-')), 1)
              ]),
              _: 1
            }),
            (_ctx.printDetail.titleDetail.sealImg)
              ? (_openBlock(), _createBlock(_component_ZPreview, {
                  key: 0,
                  authSrc: _ctx.printDetail.titleDetail.sealImg,
                  width: "100px",
                  height: "100px",
                  class: "upload-file_preview"
                }, null, 8, ["authSrc"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ])
  ]))
}